<div class="adduser-container-hgt">
  <jni-bcledger-filter
    #filter
    [bcList]="bcList"
    (bcLedgerFormEvent)="getBcLedgerFormData($event)"
    [bcSelectedId]="bcSelectedId"
    [selectedDateRange]="selectedDateRange"
    [showHeading]="false"
    [showBrandingConsultantDropDown]="brandingConsultantSection"
    [showBrandingConsultantWhoSupportsMeDropDown]="
      showBrandingConsultantWhoSupportsMeDropDown
    "
    [invokeAtLoad]="!brandingConsultantSection"
    [isFromBCLedger]="false"
    [isBAC]="isBAC"
    [isManager]="isManager"
    [overrideManager]="overrideManager"
    [showRemoveFilter]="showRemoveFilter"
    [manager]="manager"
    [fromDate]="fromDate"
    [toDate]="toDate"
    [callDateSelection]="callDateSelection"
    [disableDropDown]="disableDropDown"
    (removeFilterEvent)="removeFilter($event)"
    (bcSelectedEvent)="bcSelectedEvent()"
    (removeFilterButtonEvent)="removeFilterButtonEvent()"
    (showFilterButton)="showFilterButton()"></jni-bcledger-filter>

  <div class="row pb-4">
    <div class="col-12" *ngIf="isManager">
      <jni-location-wise-q3-grid1
        [grid1]="grid1"
        [location]="location"></jni-location-wise-q3-grid1>
    </div>
    <div class="col-12">
      <jni-bc-bac-support-breakdown
        *ngIf="!isManager"
        [bacDashboardInformation]="
          bacDashboardInformation.bacDashboardInformation || []
        "
        [dashbaordPocAdditionalFilters]="dashbaordPocAdditionalFilters"
        [totals]="bacDashboardInformation"
        [bcLedgerFilter]="bcLedgerFilter"
        (openOrderListingModal)="openOrderListingModalEmitter($event)"
        (closeSalesOrderModel)="
          changeBrandingConsultant()
        "></jni-bc-bac-support-breakdown>
    </div>
  </div>
  <div class="row pb-4">
    <!-- <div class="col-6">
      <jni-bc-gp-support-table></jni-bc-gp-support-table>
    </div> -->
    <div class="col-12">
      <jni-location-wise-q3-grid2
        *ngIf="isManager"
        [grid2]="grid2"
        [location]="location"></jni-location-wise-q3-grid2>
    </div>
    <div class="col-12">
      <jni-bac-orders-breakdown-chart
        *ngIf="!isManager"
        [bacDashboardInformation]="
          bacDashboardInformation.bacDashboardInformation || []
        "
        [dashbaordPocAdditionalFilters]="dashbaordPocAdditionalFilters"
        (closeSalesOrderModel)="changeBrandingConsultant()"
        (openOrderListingModalEvent)="
          openOrderListingModalEmitter($event)
        "></jni-bac-orders-breakdown-chart>
    </div>
  </div>
  <div class="row pb-4">
    <div class="col-6">
      <jni-billed-orders-ytd-chart
        *ngIf="!isManager"
        [billedOrdersYTD]="billedOrdersYTD"
        (closeSalesOrderModel)="changeBrandingConsultant()"
        (openOrderListingModal)="
          openOrderListingModalEmitter($event)
        "></jni-billed-orders-ytd-chart>
    </div>
    <div class="col-6">
      <!-- <jni-tiger-level-gp-chart></jni-tiger-level-gp-chart> -->
      <jni-quarterly-support-table
        *ngIf="!isManager"></jni-quarterly-support-table>
    </div>
  </div>
  <div class="row pb-4" *ngIf="!isManager">
    <jni-year-to-date-summary
      *ngIf="!isBAC"
      [yearToDateSummaryLists]="ytdSummaryList"
      [bcLedgerFilter]="bcLedgerFilter"
      [isFromDashboard]="true"
      [currentSupportPercentage]="currentSupportPercentage"
      [nextCommissionTier]="nextCommissionTier"
      [nextToGpCommission]="nextToGpCommission"
      [rollingTwelveMonthGp]="rollingTwelveMonthGp"
      [rollingTwelveMonthRevenue]="rollingTwelveMonthRevenue"
      [isFromBcReport]="true"
      (populate)="populate($event)"></jni-year-to-date-summary>
  </div>
</div>

<!-- <jni-modal-stacker
  *ngIf="orderListingDisplayModal"
  [displayModal]="orderListingDisplayModal"
  (closeEvent)="closeOrderListingModal()">
  <h1 class="panelHeading">Order Listing</h1>
  <div class="panelBody">
    <jni-orders
      [isAdditionalFilters]="true"
      [isFromSupportAllocation]="true"></jni-orders>
  </div>
</jni-modal-stacker> -->
